import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        marginBottom: 12, 
        width: '100%', 
        background: '#1b2039', 
        borderRadius: 8, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        padding: '20px 0'
    },
    helper: {
        color: '#fff',
        fontSize: 18,
        fontFamily: 'Montserrat, sans-serif', 
    }
}))

export {
    useStyles
}